import React from 'react'
import {styled} from '@material-ui/core/styles'
import {useObjectivesState} from 'lms/hooks'
import SectionTitle from 'lms/components/Detail/SectionTitle'

const List = styled('ul')({})

const Value = styled('li')({})

const nameSorter = (a, b) => a.name.localeCompare(b.name)

const Objectives = ({objectives = []}) => {
  const {data} = useObjectivesState()

  if (objectives.length === 0) return null

  const sorted = objectives
    .map(id => data.byId[id])
    .filter(Boolean)
    .sort(nameSorter)

  return (
    <>
      <SectionTitle>Learning/Training Objectives</SectionTitle>
      <List>
        {sorted.map(objective => (
          <Value key={objective.id}>{objective.name}</Value>
        ))}
      </List>
    </>
  )
}

export default Objectives
